module.exports = {
	"No notifications found.": "No notifications found.",
	"Notifications": "お知らせ",
	"See all notifications": "すべてのお知らせを表示",
	"Mark all as read": "Mark all as read"
};


//////////////////
// WEBPACK FOOTER
// ./~/@99designs/globalnav/translations/ja.json
// module id = 904
// module chunks = 32